import { render, staticRenderFns } from "./dialogRoleNotExpire.vue?vue&type=template&id=328df6c5&scoped=true"
import script from "./dialogRoleNotExpire.vue?vue&type=script&lang=js"
export * from "./dialogRoleNotExpire.vue?vue&type=script&lang=js"
import style0 from "./dialogRoleNotExpire.vue?vue&type=style&index=0&id=328df6c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328df6c5",
  null
  
)

export default component.exports